import React from 'react';
import UserConfirmation from 'js/components/route_utils/UserConfirmation';

interface RequestConfirmationDialogProps {
  type: 'save' | 'close';
  hasErrors: boolean;
  hasChanges: boolean;
  onSaveAndTest: () => void;
  onSaveAndClose: () => void;
  onCloseModal: () => void;
  onDismiss: () => void;
}

export const RequestConfirmationDialog: React.FC<RequestConfirmationDialogProps> = ({
  type,
  hasErrors,
  hasChanges,
  onSaveAndTest,
  onSaveAndClose,
  onCloseModal,
  onDismiss,
}) => {
  const isCloseAction = type === 'close';

  if (hasErrors) {
    return (
      <UserConfirmation
        title="Validation Errors & Unsaved Changes"
        message={
          isCloseAction
            ? 'You have validation errors and unsaved changes. Would you like to close without saving?'
            : 'Please fix the validation errors and save your changes before entering test mode.'
        }
        okButtonLabel={isCloseAction ? 'Close Without Saving' : 'OK'}
        cancelButtonLabel={isCloseAction ? 'Cancel' : undefined}
        okButtonTheme="primary"
        okButtonColor="primary"
        onConfirm={() => {
          onDismiss();
          if (isCloseAction) onCloseModal();
        }}
        onCancel={isCloseAction ? onDismiss : undefined}
        showCancelButton={isCloseAction}
      />
    );
  } else if (hasChanges) {
    return (
      <UserConfirmation
        title={isCloseAction ? 'Unsaved Changes' : 'Save Changes'}
        message={
          isCloseAction
            ? 'You have unsaved changes. Would you like to save them before closing?'
            : 'You have unsaved changes. Would you like to save them before entering test mode?'
        }
        okButtonLabel={isCloseAction ? 'Save & Close' : 'Save & Test'}
        cancelButtonLabel={isCloseAction ? 'Close Without Saving' : 'Cancel'}
        okButtonTheme="primary"
        okButtonColor="primary"
        onConfirm={isCloseAction ? onSaveAndClose : onSaveAndTest}
        onCancel={() => {
          onDismiss();
          if (isCloseAction) {
            onCloseModal();
          }
        }}
      />
    );
  } else {
    return null;
  }
};
